function FaqItem({ q, a }) {
  return (
    <details className="faq" data-reveal>
      <summary className="faqQ">
        <span>{q}</span>
        <span className="faqChevron" aria-hidden="true">
          ▾
        </span>
      </summary>
      <div className="faqA">{a}</div>
    </details>
  );
}

export function Faq() {
  return (
    <section className="section" id="faq">
      <div className="container">
        <div className="sectionHead" data-reveal>
          <h2 className="h2">Часто задаваемые вопросы</h2>
          <p className="muted">
            Ответы на частые вопросы о компенсациях и доказательстве авторства.
          </p>
        </div>

        <div className="faqGrid">
          <FaqItem
            q="От чего зависит размер компенсации за нарушение Ваших авторских прав?"
            a={
              <p className="muted">
                Размер компенсации за нарушение авторских прав складывается из нескольких факторов: коммерческое
                использование, значимость объекта авторских прав, длительность использования, неуказание автора, удаление
                логотипа или имени автора и др.
              </p>
            }
          />
          <FaqItem
            q="Какой срок получения компенсации за нарушение авторских прав?"
            a={
              <p className="muted">
                Срок получения компенсации за нарушение авторских прав зависит от способов урегулирования данного
                спора. В среднем авторы получают компенсацию в течение 2–4 месяцев.
              </p>
            }
          />
          <FaqItem
            q="Как доказать, что я автор?"
            a={
              <p className="muted">
                Доказать авторство можно несколькими способами: публикацией в интернете с указанием авторства, наличием
                исходных файлов или фотографий высочайшего качества и др.
              </p>
            }
          />
        </div>
      </div>
    </section>
  );
}

